function initHints() {
    $('.b-hint').each(function(){
        var $context = $(this),
            $content = $('.b-hint__content', $context);

        $(document).on('click', '.b-hint__btn', function(e) {
            e.preventDefault();
            $(this).siblings('.b-hint__content').toggle();
        });
        $(document).on('click', '.b-hint__close-btn', function(e) {
            e.preventDefault();
            $(this).closest('.b-hint__content').hide();
        });
        $(document).mouseup(function(e) {
            if (!$context.is(e.target) && $context.has(e.target).length === 0) {
                $content.hide();
            }
        });
    })
}
$(function(){
    initHints();
});